import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesSentOrdersWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.sent-orders",
  name: "Orders awaiting payment",
  description: "Sales orders currently sent to customers.",
  apps: [
    "home",
    "sales",
    "crm",
    "finance",
    "invoicing",
    "point-of-sale",
    "subscriptions",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "order_id",
          as: "waiting_payments",
        },
      ],
      where: {
        type: "condition",
        field: "status",
        operator: "eq",
        value: "sent",
      },
    },
  },
  inputs: {
    label: "Awaiting payment",
    subtext: "sent sales orders",
    icon: "orders",
    color: "warning",
  },
  dummyData: {
    value: 12,
    subtext: "awaiting payment",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
